import React, { useContext, useEffect, useRef, useState } from 'react';
// UI
import {
  alpha,
  Box,
  Button,
  Card,
  CardActionArea,
  CardMedia,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
// import Formula1Hero from '../assets/heros/Formula1.png';
//import BannerF1 from '../assets/formula1/f1-banner.jpg';
import icono1 from '../assets/formula1/benefitsIcons/icono1.svg';
import icono2 from '../assets/formula1/benefitsIcons/icono2.svg';
import icono3 from '../assets/formula1/benefitsIcons/icono3.svg';
import icono4 from '../assets/formula1/benefitsIcons/icono4.svg';
import icono5 from '../assets/formula1/benefitsIcons/icono5.svg';
import icono6 from '../assets/formula1/benefitsIcons/icono6.svg';
import calendarIcon from '../assets/formula1/calendar-icon.svg';
import ubiIcon from '../assets/formula1/ubi-icon.svg';
import bandera from '../assets/formula1/bandera.svg';
//import Formula1HeroMobile from '../assets/formula1/banner-mobile.png';
// import LowFormula1Hero from '../assets/heros/LowFormula1.png';
// import LowFormula1HeroMobile from '../assets/heros/LowFormula1Mobile.png';
// // import CIEandOasisImage from '../assets/formula1/CIEandOasis.png';
// import box01 from '../assets/formula1/box/box01.png';
// Components & Utils
import ViewContainer from '../components/shared/ViewContainer';
//import ImageLazyLoad from '../components/shared/ImageLazyLoad';
import LargeButton from '../components/shared/buttons/LargeButton';
import DownloadAppSection from '../components/shared/DownloadAppSection';
import FAQSection from '../components/shared/FAQSection';
import Carousel from '../components/carousel/Carousel';
import VenueItem from '../components/carousel/VenueItem';
// import ContactForm from '../components/shared/ContactForm';
import HalfCircle from '../components/shared/HalfCircle';
import useElementOnScreen from '../hooks/useElementOnScreen';
import { f1BoxImages } from '../utils/formula1Data';
// import { openExternalLink, scrollIntoRef } from '../utils/util';
import { UIContext } from '../providers/UIProvider';
// import ImageWithTextCard from '../components/shared/ImageWithTextCard';
import { getResponsiveObjectForFormula1 } from '../utils/carouselResponsive';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { useNavigate } from 'react-router-dom';
import { contactData } from '../utils/contactData';
import BackgroundImage from '../assets/formula1/back-f1.png';
import Ticket from '../assets/mexico2026/icons/ticket.png';
import Cup from '../assets/mexico2026/icons/cup.png';
import Vip from '../assets/mexico2026/icons/vip.png';
import Banner1 from '../assets/mexico2026/banners/Landing_Banner1.png';
import Banner2 from '../assets/mexico2026/banners/Landing_Banner2.png';
import Banner3 from '../assets/mexico2026/banners/Landing_Banner3.png';
import Iphone from '../assets/mexico2026/iphone.png';
import BackgroundImageOasis from '../assets/formula1/back-oasis.png';
import ImageLazyLoad from '../components/shared/ImageLazyLoad';
import SocialMedia from '../components/shared/SocialMedia';
import IconButtonOasis from '../components/shared/buttons/IconButtonOasis';
import FacebookIcon from '../assets/socialMedia/Facebook.svg';
import InstagramIcon from '../assets/socialMedia/Instagram.svg';
import TwitterIcon from '../assets/socialMedia/Twitter.svg';
import TiktokIcon from '../assets/socialMedia/Tiktok.svg';
import externalLinks from '../utils/json/externalLinks.json';
import { openExternalLink } from '../utils/util';
import TextInput from '../components/inputs/TextInput';
import Reaptcha from 'reaptcha';
import { useForm } from 'react-hook-form';
import { Masonry } from '@mui/lab';
import SelectInput from '../components/inputs/SelectInput';
import { getCities, sendContactForm } from '../api/extras';
import { useMutation } from 'react-query';

const defaultElementOnScreenOptions = {
  rootMargin: '0px',
  threshold: 0.95,
};

/**
 * @function Formula1
 * @author RCH010
 * @version 1.0
 * @description Formula1 view
 * This view contains promotional content for Formula1 GrandSandClub
 * Has a picture with text and a CTA, a grid with all the benefits, a carousel
 * with pictures of the box, the contact form, FAQ and downloadApp sections
 * @returns {JSX}
 */
const Mexico2026 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  useDocumentTitle('Oasis App - México 2026');
  const contactFormRef = useRef();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isTabletLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isTabletLgUp = useMediaQuery(theme.breakpoints.up('md'));
  const { setNavbarBackgroundColor } = useContext(UIContext);
  const [bannerRef, isBannerRefVisible] = useElementOnScreen(
    defaultElementOnScreenOptions
  );
  const responsiveCarouselBreakpoints = getResponsiveObjectForFormula1(theme);

  useEffect(() => {
    if (!isBannerRefVisible) {
      setNavbarBackgroundColor(theme.palette.lightBackground);
    } else {
      setNavbarBackgroundColor('transparent');
    }
  }, [
    isBannerRefVisible,
    setNavbarBackgroundColor,
    theme.palette.lightBackground,
  ]);

  return (
    <ViewContainer>
      <HalfCircle isLeftCircle left='-2em' top={isMobile ? '70vh' : '70em'} />
      <HalfCircle right='-2em' bottom='80em' opacity='.6' />
      <Box
        sx={{
          backgroundImage: `url(${Banner1})`,
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'scroll',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          zIndex: 1,
          position: 'relative',
          marginTop: '4.5em'
        }}>
        <Box
          sx={{
            zIndex: 1,
            position: 'relative',
            maxWidth: (currTheme) => currTheme.breakpoints.values.lg,
            mx: 'auto',
            px: 3,
            pt:'3em'
          }}>
          <Typography
            variant='h2'
            textAlign='center'
            sx={{ mb: 0, fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' }, fontWeight: '300' }}>
              ¡Únete a la lista de espera para
          </Typography>
          <Typography
            variant='h2'
            textAlign='center'
            sx={{ mb: 3, fontSize: { xs: '3rem', md: '3.5rem', lg: '4rem' } }}>
            <b style={{color: '#26d07c'}}>Ciudad de México, Monterrey, y Guadalajara!</b>
          </Typography>
          <Typography variant='p' fontFamily='MuseoModerno' fontSize='25px !important'>
            ¡El evento de fútbol más esperado está cada vez más cerca! Regístrate en Oasis App y recibe antes que nadie información exclusiva sobre accesos, palcos y las noticias más relevantes.
          </Typography>
          <Typography variant='p' textAlign={'center'} fontFamily='MuseoModerno' fontSize='25px !important'>
            <p>
              <b>¡No te pierdas la emoción!</b>
            </p>
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              pb: 4,
              '& img': { maxWidth: '8em' },
            }}>

            <Grid
              sx={{ mt: 2, pb: 4 }}
              container
              justifyContent='center'
              alignItems='center'
              spacing={5}>

              <Grid item xs={12} md={6}>
                <Card 
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    width: '100%',
                    borderRadius: '16px',
                    bgcolor: '#fff',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection:isMobile? 'column':'row',
                    padding: isMobile?'20px':'10px',
                  }}>
                  <img src={Ticket} alt="" />
                  <Typography variant='p' textAlign='left' fontFamily='MuseoModerno'
                    fontSize={{ xs: '1rem' }}
                    sx={{ 
                      color: (t) => t.palette.grey[900],
                    }}
                  >
                    <span><b style={{color:theme.palette.primary.dark}}>Asegura tu lugar: </b></span>Únete a la lista de espera y recibe acceso prioritario a los mejores eventos en Ciudad de México, Monterrey y Guadalajara.
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card 
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    width: '100%',
                    borderRadius: '16px',
                    bgcolor: '#fff',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection:isMobile? 'column':'row',
                    padding: isMobile?'20px':'10px',
                  }}>
                  <img src={Vip} alt="" />
                  <Typography variant='p' textAlign='left' fontFamily='MuseoModerno'
                    fontSize={{ xs: '1rem' }}
                    sx={{ 
                      color: (t) => t.palette.grey[900],
                    }}
                  >
                    <span><b style={{color:theme.palette.primary.dark}}>Descubre asientos premium: </b></span>Disfruta del máximo confort y las mejores vistas en tus eventos favoritos.
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card 
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    width: '100%',
                    borderRadius: '16px',
                    bgcolor: '#fff',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection:isMobile? 'column':'row',
                    padding: isMobile?'20px':'10px',
                  }}>
                  <img src={Cup} alt="" />
                  <Typography variant='p' textAlign='left' fontFamily='MuseoModerno'
                    fontSize={{ xs: '1rem' }}
                    sx={{ 
                      color: (t) => t.palette.grey[900],
                    }}
                  >
                    <span><b style={{color:theme.palette.primary.dark}}>Sé el primero: </b></span>Recibe actualizaciones y noticias sobre los principales eventos en México con Oasis App.
                  </Typography>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundImage: `url(${Banner2})`,
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'scroll',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          zIndex: 1,
          position: 'relative',
          paddingY: '150px',
          backgroundBlendMode: 'lighten',
          backgroundColor: 'rgb(255 255 255 / 19%)',
        }}>
        <Box
          sx={{
            zIndex: 1,
            position: 'relative',
            maxWidth: (currTheme) => currTheme.breakpoints.values.lg,
            mx: 'auto',
            overflow:'hidden'
          }}>
          <Grid
            container
            justifyContent='center'
            alignItems='center'
            spacing={isMobile||isTablet ? 0 : 5}
          >
            <Grid item xs={12} md={6} position={'relative'} display={isMobile||isTablet ? 'none' : 'block'}>
              <img src={Iphone} alt="Banner1" 
                style={{ width: '390px' }}
              />
            </Grid>
            <Grid justifyItems={isMobile||isTablet?'center':'inherit'} alignSelf={'flex-start'} item xs={12} md={6} color={ (currTheme) => currTheme.palette.primary.dark }>
              <Typography variant='p' display='block' fontSize={{xs: '20px', sm: '25px', md: '30px'}} fontFamily='MuseoModerno' lineHeight={1}>
                ¡Regístrate ahora ó contáctanos
              </Typography>
              <Typography variant='p' display='block' fontSize={{xs: '30px', sm: '35px' ,md: '50px'}} fontFamily='MuseoModerno' lineHeight={1} pb={4}>
                <b>para más información!</b>
              </Typography>
              <ContactForm/>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundImage: `url(${Banner3})`,
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'scroll',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          zIndex: 1,
          position: 'relative',
          paddingY: '3em',
        }}>
        <Box
          sx={{
            zIndex: 1,
            position: 'relative',
            maxWidth: (currTheme) => currTheme.breakpoints.values.lg,
            px: 3,
            mx: 'auto',
          }}>
          <Typography variant='p' display='block' fontSize={{xs: '20px', sm: '25px', md: '35px'}} fontFamily='MuseoModerno' lineHeight={1}>
            Contáctate con nosotros por cualquiera
          </Typography>
          <Typography variant='p' pb={2} display='block' fontSize={{xs: '30px', sm: '35px' ,md: '55px'}} fontFamily='MuseoModerno' lineHeight={1}>
            <b>de nuestros <span style={{color:'#26d07c'}}>medios oficiales.</span></b>
          </Typography>
          <Button
            color='info'
            aria-label='Store Button'
            sx={{
              fontSize: '1.6rem',
              p: 0,
              display:'flex',
              color: 'white',
            }}
            onClick={() => openExternalLink(contactData.phone.href)}>
            {contactData.phone.Icon}<span style={{marginLeft:'5px'}}>{contactData.phone.label}</span>
          </Button>
          <Button
            color='info'
            aria-label='Store Button'
            variant='text'
            sx={{
              fontSize: '1.6rem',
              p: 0,
              display:'flex',
              color: 'white',
              textTransform: 'none',
            }}
            onClick={() => openExternalLink(contactData.mail.href)}>
            {contactData.mail.Icon}<span style={{marginLeft:'5px'}}>{contactData.mail.label}</span>
          </Button>
          <Button
            color='info'
            aria-label='Store Button'
            sx={{
              fontSize: '1.6rem',
              p: 0,
              display:'flex',
              color: 'white',
            }}
            onClick={() => openExternalLink(contactData.whatsapp.href)}>
            {contactData.whatsapp.Icon}<span style={{marginLeft:'5px'}}>{contactData.whatsapp.label}</span>
          </Button>
          <Grid
            container
            justifyContent={isMobile ? 'center' : 'flex-end'}
          >
            {[{ id: 'facebook', iconPath: FacebookIcon },
              { id: 'twitter', iconPath: TwitterIcon },
              { id: 'instagram', iconPath: InstagramIcon },
              { id: 'tiktok', iconPath: TiktokIcon },
            ].map((socialNetwork) => (
              <Grid
                key={socialNetwork.id}
                item
                xs={isMobile ? 3 : 1}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}>
                <Box>
                  <a
                    target='_blank'
                    href={externalLinks[socialNetwork.id]}
                    rel='noreferrer noopener'>
                    <IconButtonOasis
                      ariaLabel={socialNetwork.id}
                      IconPath={socialNetwork.iconPath}
                      iconStyles={{ width: '50px' }}
                    />
                  </a>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <div style={{marginTop:isTabletLgUp ? '-200px' : ''}}>
        <DownloadAppSection />
      </div>
      <FAQSection />
    </ViewContainer>
  );
};

export default Mexico2026;

function ContactForm() {
  const theme = useTheme();
  const [_, setKey] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const captcha = useRef(null);
  const [captchaResponse, setCaptchaResponse] = useState(null);
  const reCaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;
  const { toggleSnackbar, updateSnackbarProps } = useContext(UIContext);
  const sendFormMutation = useMutation(sendContactForm);
  const cities = ['Monterrey', 'Guadalajara', 'Ciudad de México'];

  // TODO: Masonry NOT WORKING AS EXPECTED, RE-RENDER TO FORCE IT
  useEffect(() => {
    setTimeout(() => {
      setKey(Math.random());
    }, 300);
  }, []);


  const onVerify = async (recaptchaResponse) => {
    setCaptchaResponse(recaptchaResponse);
  };

  async function onFormSubmit(data) {
    setIsLoading(true);
    const contactForm = {
      ...data,
      message: `
      ${data.message} 
      <br>-----------------------------Interesado Mundial 2026-----------------------------------<br>
      <br>-----------------------------Contacto Mundial 2026-----------------------------------<br>
      Mensaje envaido desde: ${window.location.href}`,
      'g-recaptcha-response': captchaResponse,
    };
    
    const res = await sendFormMutation.mutateAsync(contactForm);
    if (res.success) {
      updateSnackbarProps({
        severity: 'success',
        text: 'Su mensaje ha sido enviado. Pronto nos pondremos en contacto con usted.',
      });
      captcha.current && captcha.current.reset();
      reset();
    } else {
      updateSnackbarProps({
        severity: 'error',
        text: 'Ha ocurrido un error, por favor inténtelo de nuevo.',
      });
    }
    toggleSnackbar(true);
    setIsLoading(false);
  }

  const {
    register,
    formState: { errors, isValid, touchedFields,  },
    handleSubmit,
    reset,
    trigger
  } = useForm({
    reValidateMode: 'onChange',
    mode: 'onChange',
    defaultValues: {     
      name: '',
      email: '',
      message: '',
      city: '',
      phone: '',
    },
  });
  return (
    <Paper
      sx={{
        borderRadius: 8,
        bgcolor: theme.palette.mainBackground,
        mx: 'auto',
        width: '100%',
        height: '100%',
        maxWidth: { xs: '100%', sm: '100%', md: 'sm' },
        p: 6,
      }}
      variant='elevation'
      elevation={15}>
      <Stack
        onSubmit={handleSubmit(onFormSubmit)}
        component='form'
        justifyContent='space-between'
        spacing={1}
        sx={{
          mt: 5,
        }}>
        <Masonry columns={{ xs: 1, sm: 2 }} spacing={2}>
          <TextInput
            inputVariant='name'
            register={register}
            registerName='name'
            required='Por favor ingrese su nombre.'
            error={Boolean(errors.name && touchedFields.name)}
            helperText={
              Boolean(errors.name && touchedFields.name) &&
              errors.name.message
            }
          />
          <TextInput
            inputVariant='phoneNumber'
            register={register}
            registerName={'phone'}
            required='Por favor ingrese su teléfono.'
            error={Boolean(errors.phone && touchedFields.phone)}
            helperText={
              Boolean(errors.phone && touchedFields.phone) &&
              errors.phone.message
            }
          />
          <TextInput
            inputVariant='email'
            registerName='email'
            register={register}
            required='Por favor ingrese su correo.'
            error={Boolean(errors.email && touchedFields.email)}
            helperText={
              Boolean(errors.email && touchedFields.email) &&
              errors.email.message
            }
          />
          <FormControl color='secondary'>
            <InputLabel id={`select-1`}>*Ciudad de interés</InputLabel>
            <Select
              required={true}
              // defaultValue={''}
              {...register('city', {
                onChange:(e)=>{
                  trigger('name');
                  trigger('city');
                },
                required: true,
              })}
              variant='outlined'
              displayEmpty
              // onChange={()=>setCities(cities)}
            >
              {cities.map((city) => (
                <MenuItem key={city} value={city}>{city}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Masonry>
        <TextInput
          additionalStyles={{ 
            '& label': {
              fontSize: '16px',
            },
          }}
          style={{ 
            padding: '8px',
          }}
          placeholder=''
          inputVariant='text'
          registerName='message'
          register={register}
          multiline
          label='*Deja un mensaje, dudas y/o preferencias.'
          minRows={4}
          required='Por favor describa el proposito del mensaje.'
          error={Boolean(errors.message && touchedFields.message)}
          helperText={
            Boolean(errors.message && touchedFields.message) &&
            errors.message.message
          }
        />
        <Reaptcha
          ref={captcha}
          sitekey={reCaptchaKey}
          onVerify={onVerify}
          onExpire={() => setCaptchaResponse(null)}
          onError={() => setCaptchaResponse(null)}
          size='normal'
          theme='dark'
        />
        <div style={{height:'30px'}}></div>
        <Button
          type='submit'
          color='secondary'
          aria-label='Contactar'
          variant='contained'
          size='large'
          disabled={!isValid || !captchaResponse || isLoading}
          sx={{ textTransform: 'uppercase', fontSize: 18 }}>
          {isLoading ? <CircularProgress size={30} /> : 'Enviar'}
        </Button>
      </Stack>
    </Paper>
  )
}